import { StarIcon } from '@radix-ui/react-icons';

const HumanReviewBanner = () => {
  return (
    <div className="bg-[#F9FAFB] border border-[#E2E8F0] rounded-lg p-4 mt-6">
      <div className="flex items-start">
        <div className="flex-1">
          <div className="flex items-center space-x-1 mb-1">
            <StarIcon className="h-4 w-4 text-yellow-400" />
            <span className="font-medium">Need professional human review?</span>
          </div>
          <p className="text-sm text-[#020817]">
            While AI evaluation provides valuable insights, for mission-critical content or sensitive materials,
            we recommend complementing it with expert human review.
            <a
              href="https://alconost.com/en/localization/proofreading"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#3B82F6] hover:text-blue-800 mt-2 block"
            >
              Learn about our human review services →
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default HumanReviewBanner; 